import { DecimalPipe } from '@angular/common';
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TableService } from 'src/app/shared/service/table.service';
import { k } from 'src/environments/properties';


@Component({
  selector: 'app-validate-token',
  templateUrl: './validate-token.component.html',
  styleUrls: ['./validate-token.component.scss'],
  providers: [TableService, DecimalPipe]
})
export class ValidateTokenComponent {


    constructor(private route: ActivatedRoute , 
        private router: Router
    ) {}

    ngOnInit(): void {
        let token = this.route.snapshot.paramMap.get('token');
        const id = this.route.snapshot.paramMap.get('id');
        sessionStorage.setItem(k.user_id, '');
        sessionStorage.setItem(k.token, String(token));
        sessionStorage.setItem(k.user_name, 'Usuario sistema');
        sessionStorage.setItem(k.tipoGrupo, '');
        sessionStorage.setItem(k.correo, 'jobsite@bcr.gob.sv');           
        document.cookie = "access_token=" + token + "; path=/; secure; samesite=strict;";

        //redirigir
        //visor/:id
        // Redireccionar al visor
        this.router.navigate(['/visor', id]);

    }
}